// Tipos de arquivo da "Lista de arquivos" (miniaturas, rótulos e limites).

export const KINDS = {
  image: { label: "IMG", one: "imagem", many: "imagens", color: "#2D7BE8" },
  video: { label: "VID", one: "vídeo", many: "vídeos", color: "#6a4fd8" },
  audio: { label: "ÁUD", one: "áudio", many: "áudios", color: "#f08c1b" },
  pdf: { label: "PDF", one: "PDF", many: "PDFs", color: "#d93a3a" },
  doc: { label: "DOC", one: "documento", many: "documentos", color: "#5c6bc0" },
};

const EXT_KIND = {
  jpg: "image", jpeg: "image", png: "image", gif: "image", webp: "image", bmp: "image",
  mp4: "video", mov: "video", avi: "video", mkv: "video", "3gp": "video", webm: "video",
  mp3: "audio", ogg: "audio", wav: "audio", m4a: "audio", aac: "audio", opus: "audio",
  pdf: "pdf",
};

// mediaType gravado pelo servidor, ou o nome do arquivo quando ainda não subiu.
export const kindOf = (mediaType, fileName) => {
  const mt = String(mediaType || "").toLowerCase();
  if (mt === "application/pdf") return "pdf";
  if (mt.startsWith("image/")) return "image";
  if (mt.startsWith("video/")) return "video";
  if (mt.startsWith("audio/")) return "audio";
  const ext = String(fileName || "").split(".").pop().toLowerCase();
  return EXT_KIND[ext] || "doc";
};

export const formatBytes = (bytes) => {
  const n = Number(bytes || 0);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} MB`;
};

// "3 imagens · 1 PDF"
export const describeKinds = (items) => {
  const count = {};
  items.forEach((it) => {
    count[it.kind] = (count[it.kind] || 0) + 1;
  });
  return Object.entries(count)
    .map(([k, n]) => `${n} ${n > 1 ? KINDS[k].many : KINDS[k].one}`)
    .join(" · ");
};

// Limites do servidor e do WhatsApp.
export const MAX_FILE_BYTES = 64 * 1024 * 1024;
export const WHATSAPP_VIDEO_BYTES = 16 * 1024 * 1024;

export const ACTIVE_CAMPAIGN = ["PROGRAMADA", "EM_ANDAMENTO"];

export const CAMPAIGN_STATUS = {
  INATIVA: "inativa",
  PROGRAMADA: "agendada",
  EM_ANDAMENTO: "em andamento",
  CANCELADA: "cancelada",
  FINALIZADA: "finalizada",
};

export const fileListUrl = (fileListId, path) =>
  `${process.env.REACT_APP_BACKEND_URL}/public/fileList/${fileListId}/${encodeURIComponent(path)}`;
